import React, { createContext, useContext, useState, useEffect } from 'react';
import { publicApi, adminApi } from '../config/axios';
import tokenStore from '../config/tokenStore';

const AuthContext = createContext({});

export function AuthProvider({ children }) {
  const [user, setUser]           = useState(null);
  const [loading, setLoading]     = useState(true);

  // On mount, restore session from sessionStorage
  useEffect(() => {
    const token = tokenStore.init();
    if (token) {
      adminApi.get('/users/show')
        .then(res => setUser(res.data?.data))
        .catch(() => tokenStore.clear())
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (email, password) => {
    const res = await publicApi.post('/users/login', { email, password });
    const data = res.data?.data;
    if (data?.type !== 'ADMIN') {
      // The shared customer login route has already issued a session (token + cookie) to this
      // non-admin account. Revoke it right now so nothing outlives the refusal.
      if (data?.access_token) {
        try { await publicApi.get('/users/logout', { headers: { Authorization: `Bearer ${data.access_token}` } }); } catch { /* best effort: the token is never stored */ }
      }
      throw new Error('Only Admin Can Access!');
    }
    tokenStore.set(data.access_token);
    setUser(data);
    return data;
  };

  const logout = () => {
    tokenStore.clear();
    setUser(null);
  };

  const updateUser = (updates) => setUser(prev => ({ ...prev, ...updates }));

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, updateUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
